import { AApi } from "@/service/AApi";
const API = new AApi({ url: "bills", isConvertFormData: true });
export default API;